import React from 'react';
import {
  Button, IconButton, Paper, DialogTitle, DialogContent, DialogActions, TextField, Tooltip, Divider, Checkbox, InputLabel, MenuItem, FormControl, Select, FormControlLabel, Stack, Typography,} from '@mui/material';
import { Add, Delete, Edit, MedicalServices, FamilyRestroom, Visibility, Person, LocationOn, PhoneAndroid, Badge, Warning, FolderShared, Email } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, C, UploadFiles, HardConfirmDialog } from '../include';
import _ from 'underscore';
import { Link } from 'react-router-dom';




function computeAge(birthday){
    var age = 18;
    if(birthday){
      //Converte DD/MM/YYYY em um Date object
      let [day, month, year] = birthday.split('/')
      const birthdayObj = new Date(+year, +month - 1, +day)
      
      var diff_ms = Date.now() - birthdayObj; //difference in milliseconds
      var age_dt = new Date(diff_ms); 
      age = Math.abs(age_dt.getUTCFullYear() - 1970); //difference in years between the age Date object and the year 1970 (UNIX epoch)
    }    
    return age;
}
  
  
export class EditPatient extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      name: this.props.row ? this.props.row.name : '',
      company_id: this.props.row ? this.props.row.company_id : this.props.user.company_id,
      birthday: this.props.row ? this.props.row.birthday : new Date().toISOString().substring(0, 10),
      gender: this.props.row ? this.props.row.gender : -1,
      mobile: this.props.row ? this.props.row.mobile : "",
      mobile2: this.props.row ? this.props.row.mobile2 : "",
      email: this.props.row ? this.props.row.email : "",
      cep: this.props.row ? this.props.row.cep : "",
      address: this.props.row ? this.props.row.address : "",
      city: this.props.row ? this.props.row.city : "",
      state: this.props.row ? this.props.row.state : "",
      cpf: this.props.row ? this.props.row.cpf : "",
      profession: this.props.row ? this.props.row.profession : "",
      maritalstatus: this.props.row ? this.props.row.maritalstatus : -1,
      idt_front_file: this.props.row ? this.props.row.idt_front_file : -1,
      idt_back_file: this.props.row ? this.props.row.idt_back_file : -1,
      previous_idt_front_file: this.props.row ? this.props.row.idt_front_file : -1,
      previous_idt_back_file: this.props.row ? this.props.row.idt_back_file : -1,
      allow_contact: this.props.row ? this.props.row.allow_contact : true,
      invalid_cpf: false,
      invalid_cpf_legalrepresentative: false,
      doctor: this.props.row ? this.props.row.doctor : "Não há",
      doctor_phone: this.props.row ? this.props.row.doctor_phone : "(00) 00000-0000",
      emergencyname: this.props.row ? this.props.row.emergencyname : "Não há",
      emergencyphone: this.props.row ? this.props.row.emergencyphone : "(00) 00000-0000",
      health_insurance: this.props.row ? this.props.row.health_insurance : "Não há",
      card: this.props.row ? this.props.row.card : "Não há",
      hospital: this.props.row ? this.props.row.hospital : "Não há",      
      legalcity: this.props.row ? this.props.row.legalcity : " ",
      legalcpf: this.props.row ? this.props.row.legalcpf : " ",
      legalmaritalstatus: this.props.row ? this.props.row.legalmaritalstatus : -1,
      legalname: this.props.row ? this.props.row.legalname : " ",
      legalprofession: this.props.row ? this.props.row.legalprofession : " ",
      legalstate: this.props.row ? this.props.row.legalstate : " ",
      age: this.props.row ? computeAge(this.props.row.birthday) : 18,
      lat: this.props.row ? this.props.row.latitude : '',
      long: this.props.row ? this.props.row.longitude : '',
    };
  }


  handleSubmit = async () => {
    if (this.state.invalid_cpf || this.state.invalid_cpf_legalrepresentative) return;
    if (!this.props.edit) {
      this.props.api
        .post('/Patients/', { name: this.state.name, company_id: this.state.company_id, birthday: this.state.birthday, gender: this.state.gender, mobile: this.state.mobile, mobile2: this.state.mobile2, email: this.state.email, cep: this.state.cep, address: this.state.address, city: this.state.city, state: this.state.state, cpf: this.state.cpf, profession: this.state.profession, maritalstatus: this.state.maritalstatus, idt_front_file: this.state.idt_front_file, idt_back_file: this.state.idt_back_file, allow_contact: this.state.allow_contact,doctor: this.state.doctor, doctor_phone: this.state.doctor_phone, emergencyname: this.state.emergencyname, emergencyphone: this.state.emergencyphone, health_insurance: this.state.health_insurance, card: this.state.card, hospital: this.state.hospital, legalcity: this.state.legalcity, legalcpf: this.state.legalcpf, legalmaritalstatus: this.state.legalmaritalstatus, legalname: this.state.legalname, legalprofession: this.state.legalprofession, legalstate: this.state.legalstate, latitude: this.state.lat, longitude: this.state.long })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Paciente criado com sucesso');
        })
        .catch(error => {
          this.props.alert('Ocorreu um erro ao criar o registro: '+error);
        })
    } else {
      this.props.api
        .put('/Patient/' + this.props.row.id, { id: this.props.row.id, name: this.state.name, company_id: this.state.company_id, birthday: this.state.birthday, gender: this.state.gender, mobile: this.state.mobile, mobile2: this.state.mobile2, email: this.state.email, cep: this.state.cep, address: this.state.address, city: this.state.city, state: this.state.state, cpf: this.state.cpf, profession: this.state.profession, maritalstatus: this.state.maritalstatus, idt_front_file: this.state.idt_front_file, idt_back_file: this.state.idt_back_file, previous_idt_front_file: this.state.previous_idt_front_file, previous_idt_back_file: this.state.previous_idt_back_file, allow_contact: this.state.allow_contact,doctor: this.state.doctor, doctor_phone: this.state.doctor_phone, emergencyname: this.state.emergencyname, emergencyphone: this.state.emergencyphone, health_insurance: this.state.health_insurance, card: this.state.card, hospital: this.state.hospital, legalcity: this.state.legalcity, legalcpf: this.state.legalcpf, legalmaritalstatus: this.state.legalmaritalstatus, legalname: this.state.legalname, legalprofession: this.state.legalprofession, legalstate: this.state.legalstate, latitude: this.state.lat, longitude: this.state.long })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert(r.message);
        })
        .catch(() => this.props.alert('Ocorreu um erro ao salvar alterações'));
    }
  };


  
  cpfMask = (value, patient) => {
    var theRet = value
      .replace(/\D/g, '') // substitui qualquer caracter que não seja número por nada
      .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de número, o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de número
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 núumeros seguidos de um traço e não deixa ser digitado mais nada
    
    //Valida o CPF
    if(theRet.length === 14){
      var strCPF = theRet.replace(/\D/g, '')
      var invalidCPF = false;
      var Soma, Resto;
      Soma = 0;
      if (strCPF === "00000000000") invalidCPF = true;

      for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto === 10) || (Resto === 11))  Resto = 0;
      if (Resto !== parseInt(strCPF.substring(9, 10)) ) invalidCPF = true;

      Soma = 0;
      for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto === 10) || (Resto === 11))  Resto = 0;
      if (Resto !== parseInt(strCPF.substring(10, 11) ) ) invalidCPF = true;
      if(patient)
        this.setState({invalid_cpf: invalidCPF});
      else
        this.setState({invalid_cpf_legalrepresentative: invalidCPF});
    }
    else{
      this.setState({invalid_cpf: true});
    }
    
    return theRet
  }
  
  phoneMask = (value) => {
    return value
      .replace(/\D+/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2') // Trata o caso de um número fixo de telefone, que tem 8 números
      .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3') //Trata o caso de um número de celular, que tem 9 números
      .replace(/(-\d{4})\d+?$/, '$1')
  }

  cepMask = (value) => {
    var theRet = value
      .replace(/\D+/g, '')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{3})\d+?$/, '$1')
    
    //Valida o CEP
    if(theRet.length === 9){
      var strCEP = theRet.replace(/\D/g, '')      
      fetch(`https://viacep.com.br/ws/${strCEP}/json/`)
        .then((res) => res.json())
        .then((data) => {
           if(this.state.address === "") this.setState({address: data.logradouro}) 
           if(this.state.city === "") this.setState({city: data.localidade})
           if(this.state.state === "") this.setState({state: data.uf})
        })
        .catch(error => {
           //console.log(error);
           this.props.alert("Busca de CEP nos Correios falhou")
        });
        
      this.props.api
        .get('/PatientLocation/' + strCEP)
        .then((r) => {
          if(r.error)
            this.props.alert(r.message);
          else if(("latitude" in r.message) && ("longitude" in r.message))
            this.setState({lat: r.message.latitude,long: r.message.longitude});
        })
        .catch((error) => this.props.alert('Ocorreu um erro ao solicitar coordenadas - ' + error));
        
        
    }
    
    return theRet;
  }

  handleDateChange = (e) => {
    var strDate = "" + ( (e.$D)>9 ? e.$D : "0"+e.$D )+ "/" + ( (e.$M+1)>9 ? (e.$M+1) : "0"+(e.$M+1) )+ "/" + e.$y;
    this.setState({ birthday: strDate, age: computeAge(strDate) });
  }
  

  handleDBRecord = (record, error, side) => {
    if(!error){
      if(side === "frente")
        this.setState({idt_front_file: record.id });
      else if(side === "verso")
        this.setState({idt_back_file: record.id });
    }
  }
  
 
  
  render() {
    return (
      <form onSubmit={this.handleSubmit} >
        <DialogTitle style={{ minWidth: '400px' }}>
          {this.props.edit ? 'Editar Paciente' : 'Adicionar Paciente'}
        </DialogTitle>
        <DialogContent>
          <D h="1rem" />
          {(this.props.user.role==="superuser") &&
            <>
              <TextField
                fullWidth
                variant="outlined"
                label="Empresa"
                value={this.state.company_id}
                onChange={(e) => this.setState({ company_id: e.target.value })}
                required
              />
              <D h="1rem" />
            </>
          }
          <TextField
            fullWidth
            variant="outlined"
            label="Nome"
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })}
            required
          />
          <D h="1rem" />
          <FormControl fullWidth>
            <InputLabel id="select-type">Sexo</InputLabel>
            <Select
              labelId="select-C.GenderType"
              id="select-gt"
              value={this.state.gender}
              label="Sexo"
              onChange={(e) => this.setState({gender: e.target.value})}
            >
              {Object.keys(C.GenderType).map(key => {
                  return <MenuItem key={key} value={key}>{C.GenderType[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <D h="1rem" />          
          <TextField
            fullWidth
            variant="outlined"
            label="Celular (xx) xxxxx-xxxx"
            value={this.state.mobile}
            onChange={(e) => this.setState({ mobile: this.phoneMask(e.target.value) })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Celular Alternativo (xx) xxxxx-xxxx"
            value={this.state.mobile2}
            onChange={(e) => this.setState({ mobile2: this.phoneMask(e.target.value) })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Email"
            value={this.state.email}
            onChange={(e) => this.setState({ email: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="CEP xxxxx-xxx"
            value={this.state.cep}
            onChange={(e) => this.setState({ cep: this.cepMask(e.target.value) })}
            required
          />
          <D h="1rem" />          
          <TextField
            fullWidth
            variant="outlined"
            label="Endereço"
            value={this.state.address}
            onChange={(e) => this.setState({ address: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Cidade"
            value={this.state.city}
            onChange={(e) => this.setState({ city: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Estado"
            value={this.state.state}
            onChange={(e) => this.setState({ state: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Latitude"
            value={this.state.lat}
            onChange={(e) => this.setState({ lat: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Longitude"
            value={this.state.long}
            onChange={(e) => this.setState({ long: e.target.value })}
          />
          <D h="1rem" />          
          <TextField
            fullWidth
            variant="outlined"
            label="CPF xxx.xxx.xxx-xx"
            value={this.state.cpf}
            onChange={(e) => this.setState({ cpf: this.cpfMask(e.target.value,true) })}
            error={this.state.invalid_cpf}
            helperText={this.state.invalid_cpf ? "CPF inválido" : ""}
            required
          />
          <D h="1rem" />          
          <TextField
            fullWidth
            variant="outlined"
            label="Profissão"
            value={this.state.profession}
            onChange={(e) => this.setState({ profession: e.target.value })}
            required
          />
          <D h="1rem" />
          <FormControl fullWidth>
            <InputLabel id="select-type">Estado Civil</InputLabel>
            <Select
              labelId="select-type"
              id="select-t"
              value={this.state.maritalstatus}
              label="Estado Civil"
              onChange={(e) => this.setState({maritalstatus: e.target.value})}
            >
              {Object.keys(C.MaritalStatusType).map(key => {
                  return <MenuItem key={key} value={key}>{C.MaritalStatusType[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>          
          <D h="1rem" /> 
          <Paper style={{padding: '0.5rem'}} sx={{backgroundColor: (this.state.age < 18) ? "#f5f9fd" : "white"}} elevation={(this.state.age < 18) ? 1 : 0}>        
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
            <DatePicker 
              label="Data de Nascimento"
              onChange={this.handleDateChange}
              value={dayjs(this.state.birthday,'DD/MM/YYYY')}               
              slotProps={{ textField: { fullWidth: true, required: true } }}
              sx={{ width: "100%" }}
            />
            </LocalizationProvider> 
            {(this.state.age < 18) && <>
              <D h="0.4rem" />
              <Stack direction="row" spacing={2} style={{padding: '1rem'}}>
                <FamilyRestroom color="primary" />
                <Typography variant="button" gutterBottom sx={{ display: 'block' }} color="primary">Paciente Menor de Idade</Typography>
              </Stack>
              <D h="1rem" />

              <TextField
                fullWidth
                variant="outlined"
                label="Nome do Responsável Legal"
                value={this.state.legalname}
                onChange={(e) => this.setState({ legalname: e.target.value })}
                required
              />
              <D h="1rem" /> 
              <TextField
                fullWidth
                variant="outlined"
                label="CPF do Responsável Legal"
                value={this.state.legalcpf}
                onChange={(e) => this.setState({ legalcpf: this.cpfMask(e.target.value,false) })}
                error={this.state.invalid_cpf_legalrepresentative}
                helperText={this.state.invalid_cpf_legalrepresentative ? "CPF inválido" : ""}
                required
              />
              <D h="1rem" />              
              <FormControl fullWidth>
                <InputLabel id="select-type">Estado Civil do Responsável Legal</InputLabel>
                <Select
                  labelId="select-type"
                  id="select-rl"
                  value={this.state.legalmaritalstatus}
                  label="Estado Civil"
                  onChange={(e) => this.setState({legalmaritalstatus: e.target.value})}
                >
                  {Object.keys(C.MaritalStatusType).map(key => {
                      return <MenuItem key={key} value={key}>{C.MaritalStatusType[key]}</MenuItem>
                    })
                  }
                </Select>
              </FormControl>          
              <D h="1rem" />  
              <TextField
                fullWidth
                variant="outlined"
                label="Profissão do Responsável Legal"
                value={this.state.legalprofession}
                onChange={(e) => this.setState({ legalprofession: e.target.value })}
                required
              />
              <D h="1rem" />
              <TextField
                fullWidth
                variant="outlined"
                label="Cidade do Responsável Legal"
                value={this.state.legalcity}
                onChange={(e) => this.setState({ legalcity: e.target.value })}
                required
              />
              <D h="1rem" />
              <TextField
                fullWidth
                variant="outlined"
                label="Estado do Responsável Legal"
                value={this.state.legalstate}
                onChange={(e) => this.setState({ legalstate: e.target.value })}
                required
              />
              <D h="1rem" />  
            </>}   
          </Paper>
          <D h="1rem" />
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".jpg, .jpeg"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error, "frente") }}
            registerIntoDB={true}
            caption="Identidade (frente)"
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Identidade (frente)"
            value={this.state.idt_front_file}
            onChange={(e) => this.setState({ idt_front_file: e.target.value })}
          />
          <D h="1rem" />
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".jpg, .jpeg"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error, "verso") }}
            registerIntoDB={true}
            caption="Identidade (verso)"
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Identidade (verso)"
            value={this.state.idt_back_file}
            onChange={(e) => this.setState({ idt_back_file: e.target.value })}
          />
          <D h="1rem" />
          <FormControlLabel control={
            <Checkbox 
              checked={this.state.allow_contact} 
              onChange={(e) => this.setState({ allow_contact: e.target.checked })} 
            />
          } label="Permito contatos pelos canais digitais" />
          <D h="1 rem" />
          <Paper style={{padding: '0.5rem'}} sx={{backgroundColor: "#f5f9fd"}}>
          <Stack direction="row" spacing={2} style={{padding: '1rem'}}>
            <MedicalServices color="primary" />
            <Typography variant="button" gutterBottom sx={{ display: 'block' }} color="primary">Em Caso de Emergência:</Typography>
          </Stack>          
          <D h="1 rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Em Caso de Emergência Contactar"
            value={this.state.emergencyname}
            onChange={(e) => this.setState({ emergencyname: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Telefone do Contato de Emergência"
            value={this.state.emergencyphone}
            onChange={(e) => this.setState({ emergencyphone: this.phoneMask(e.target.value) })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Convênio Médico"
            value={this.state.health_insurance}
            onChange={(e) => this.setState({ health_insurance: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Número do Cartão do Convênio Médico"
            value={this.state.card}
            onChange={(e) => this.setState({ card: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Hospital para Encaminhamento"
            value={this.state.hospital}
            onChange={(e) => this.setState({ hospital: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Médico de Emergência"
            value={this.state.doctor}
            onChange={(e) => this.setState({ doctor: e.target.value })}
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Telefone do Médico"
            value={this.state.doctor_phone}
            onChange={(e) => this.setState({ doctor_phone: this.phoneMask(e.target.value) })}
          />          
          </Paper>
          <D h="2rem" />
          <Stack direction="row" justifyContent="flex-end" spacing={1} >
            <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
              Cancelar
            </Button>
            <Button variant="outlined" color="primary" onClick={this.handleSubmit} disabled={this.state.invalid_cpf}>
              Salvar
            </Button>
          </Stack>
        </DialogContent>
      </form>
    );
  }
}
















export class ViewPatient extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      name: this.props.row ? this.props.row.name : '',
      company_id: this.props.row ? this.props.row.company_id : this.props.user.company_id,
      birthday: this.props.row ? this.props.row.birthday : new Date().toISOString().substring(0, 10),
      gender: this.props.row ? this.props.row.gender : -1,
      mobile: this.props.row ? this.props.row.mobile : "",
      mobile2: this.props.row ? this.props.row.mobile2 : "",
      email: this.props.row ? this.props.row.email : "",
      cep: this.props.row ? this.props.row.cep : "",
      address: this.props.row ? this.props.row.address : "",
      city: this.props.row ? this.props.row.city : "Rio de Janeiro",
      state: this.props.row ? this.props.row.state : "RJ",
      latitude: this.props.row ? this.props.row.latitude : "",
      longitude: this.props.row ? this.props.row.longitude : "",
      cpf: this.props.row ? this.props.row.cpf : "",
      profession: this.props.row ? this.props.row.profession : "",
      maritalstatus: this.props.row ? this.props.row.maritalstatus : -1,
      idt_front_file: this.props.row ? this.props.row.idt_front_file : -1,
      idt_back_file: this.props.row ? this.props.row.idt_back_file : -1,
      allow_contact: this.props.row ? this.props.row.allow_contact : true,
      invalid_cpf: false,
      invalid_cpf_legalrepresentative: false,
      doctor: this.props.row ? this.props.row.doctor : "",
      doctor_phone: this.props.row ? this.props.row.doctor_phone : "",
      emergencyname: this.props.row ? this.props.row.emergencyname : "",
      emergencyphone: this.props.row ? this.props.row.emergencyphone : "",
      health_insurance: this.props.row ? this.props.row.health_insurance : "",
      card: this.props.row ? this.props.row.card : "",
      hospital: this.props.row ? this.props.row.hospital : "",      
      legalcity: this.props.row ? this.props.row.legalcity : " ",
      legalcpf: this.props.row ? this.props.row.legalcpf : " ",
      legalmaritalstatus: this.props.row ? this.props.row.legalmaritalstatus : -1,
      legalname: this.props.row ? this.props.row.legalname : " ",
      legalprofession: this.props.row ? this.props.row.legalprofession : " ",
      legalstate: this.props.row ? this.props.row.legalstate : " ",
      age: this.props.row ? computeAge(this.props.row.birthday) : 18,
    };
  }

  render() {
    return (
      <form>
        <DialogTitle style={{ minWidth: '400px' }}>
          Dados do Paciente
        </DialogTitle>
        <DialogContent>
          <Stack direction="row" spacing={1} >
            <Person/>
            <Stack>
            <Typography gutterBottom >{this.state.name}</Typography>
            <Typography gutterBottom >{this.state.birthday} - {this.state.age} anos - {C.GenderType[ this.state.gender ]}</Typography>
            </Stack>
          </Stack>
          <D h="1rem" />
          <Stack direction="row" spacing={1} >
            <PhoneAndroid/>
            <Typography gutterBottom >Tel. {this.state.mobile} / {this.state.mobile2}</Typography>    
          </Stack> 
          <D h="1rem" />
          <Stack direction="row" spacing={1} >
            <Email/>
            <Typography gutterBottom >Email. {this.state.email}</Typography>    
          </Stack>
          <D h="1rem" />     
          <Stack direction="row" spacing={1} >
            <LocationOn/>
            <Stack>
            <Typography gutterBottom >{this.state.address}</Typography>
            <Typography gutterBottom >{this.state.city} - {this.state.state}</Typography>
            <Typography gutterBottom >{this.state.cep}</Typography>
            <Typography gutterBottom >Lat: {this.state.latitude}, Long: {this.state.longitude}</Typography>
            </Stack>
          </Stack>
          <D h="1rem" />
          <Stack direction="row" spacing={1} >
            <Badge/>
            <Stack>
            <Typography gutterBottom >CPF: {this.state.cpf}</Typography>
            <Typography gutterBottom >{this.state.profession}, {C.MaritalStatusType[this.state.maritalstatus]}</Typography>
            </Stack>
          </Stack>
          <D h="1rem" />
          {(this.state.age < 18)  && <>
          <Stack direction="row" spacing={1} >
            <FamilyRestroom/>
            <Stack>
            <Typography gutterBottom >{this.state.legalname}</Typography>
            <Typography gutterBottom >{this.state.legalcpf}</Typography>
            <Typography gutterBottom >{this.state.legalprofession}, {C.MaritalStatusType[this.state.legalmaritalstatus]}, </Typography>
            <Typography gutterBottom >{this.state.legalcity} - {this.state.legalstate}</Typography>
            </Stack>
          </Stack>
          <D h="1rem" />
          </>}
          <Stack direction="row" spacing={1} >
            <MedicalServices/>
            <Stack><Typography gutterBottom >{this.state.emergencyname}</Typography>
            <Typography gutterBottom >{this.state.emergencyphone}</Typography>
            <Typography gutterBottom >{this.state.health_insurance} - Nr. {this.state.card}</Typography>
            <Typography gutterBottom >{this.state.hospital}</Typography>
            <Typography gutterBottom >{this.state.doctor} - {this.state.doctor_phone}</Typography> 
            </Stack>
          </Stack>      
          <D h="1rem" />          
          <Stack direction="row" spacing={1} >
            <Warning/>
            <Typography gutterBottom >{this.state.allow_contact ? "" : "NÃO "}Permite contato pelos canais digitais</Typography>
          </Stack>

          <D h="1rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            OK
          </Button>
        </DialogActions>
      </form>
    );
  }
}



















export class Patient extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchField: '',
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === 'w'
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: 'id', headerName: 'ID', width: 70 },
      { field: 'name', headerName: 'Nome', width: 250 },
      { field: 'company_id', headerName: 'Empresa', width: 90 },
      { field: 'age', headerName: 'Idade', width: 110 },
      { field: 'profession', headerName: 'Profissão', width: 130 },
      { field: 'cpf', headerName: 'CPF', width: 130 }, 
    ];
  }

  componentDidMount() {
    this.updateData();
  }

  updateData = (page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) => {
    this.setState({ loading: true });
    this.props.api
      .get('/Patients', { params: { page, pageSize, search: searchField } })
      .then((r) => {
        for(var row in r.patients){
          var birthday = new Date(r.patients[row]["birthday"]); 
          r.patients[row]["birthday"] = birthday.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', timeZoneName: 'short' }).substring(0, 10);
          r.patients[row]["age"] =  computeAge(r.patients[row]["birthday"]);      
          r.patients[row]["maritalstatustring"] = C.MaritalStatusType[ r.patients[row]["maritalstatus"] ];
          r.patients[row]["genderstring"] = C.GenderType[ r.patients[row]["gender"] ];
          if(r.patients[row]["mobile2"] === "null") r.patients[row]["mobile2"] = "";
        }
        this.setState({
          dataTable: r.patients || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.includes(i) ? _.without(this.state.selectedRows, i) : _.union(this.state.selectedRows, [i])
    });
  };
  

  
  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;
    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <> 
              <Divider sx={{ paddingRight: '5px' }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length === 1 && (
                <>
                  <Tooltip title="Editar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <EditPatient
                            edit
                            row={this.state.selectedRows[0]}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              this.updateData();
                            }}
                            user={this.props.user}
                          />
                        )
                      }
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              {this.state.selectedRows.length > 0 && (
                <>
                  <Tooltip title="Excluir selecionados" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <HardConfirmDialog
                            title="Excluir Itens"
                            msg="Ao confirmar, os itens serão excluídos e não poderão ser recuperados"
                            reg={"Procedimentos, Documentos, Respostas de Questionários, Sessões de Atendimento serão apagados"}
                            onCancel={this.props.dialogClose}
                            onConfirm={() => {
                              for (let row of this.state.selectedRows) {
                                this.props.api
                                  .delete("/Patient/" + row.id)
                                  .then((r) => {
                                    this.props.alert(r.message);
                                    this.props.dialogClose();
                                    this.setState({ selectedRows: [] });
                                    this.updateData();
                                  })
                                  .catch(() => this.props.alert("Ocorreu um erro ao excluir o registro"));
                              }
                            }}
                          />
                        )
                      }
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
              {this.state.selectedRows.length === 1 && (
                <>
                  <Divider sx={{ paddingRight: '5px' }} orientation="vertical" flexItem />
                  <D size="0.5rem" /> 
                  <Tooltip title="Visualizar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <ViewPatient
                            edit
                            row={this.state.selectedRows[0]}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              //this.updateData();
                            }}
                            user={this.props.user}
                          />
                        )
                      }
                    >
                      <Visibility />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                  <Tooltip title="Prontuário" arrow>
                    <Link to={"/medicalrecord?r="+this.state.selectedRows[0].id} onClick={() => this.props.changeView('/medicalrecord')}>
                    <IconButton>
                      <FolderShared />
                    </IconButton>
                    </Link>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: '12px' }}
                  onClick={() =>
                    this.props.dialog(
                      <EditPatient
                        edit={false}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                        user={this.props.user}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />
        
        <Paper sx={{ width: '100%', height: '800px', overflow: 'hidden' }}>
          <DataGrid
            rows={dataTable}
            columns={this.columns}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </Paper>
      </D>
    );
  }
}
